<template>
    <div class="block-page">
        <div class="page-title">板块布局</div>
        <div class="page-content">
            
            <table class="bl-table">
                
                <thead>
                <tr>
                    <th>顺序</th>
                    <th>功能名称</th>
                    <th class="text-left" width="150px">自定义名称</th>
                    <th>页面启用</th>
                    <th>操作</th>
                </tr>
                </thead>
                <tbody ref="sortTable">
                <template v-for="(item) in mpStore.tabs">
                    <tr :key="item.name" :data-id="item.name">
                        <td>
                            <div class="sort-btn drag-handle"></div>
                        </td>
                        <td>{{ item.title }}</td>
                        <td>
                            <at-input v-model="item.custom_title"></at-input>
                        </td>
                        <td>
                            <switch-button v-model="item.enabled"></switch-button>
                        </td>
                        <td>
                            <a class="del-btn" v-if="item.name !== 'my'" @click="deleteTab(item)">删除</a>
                        </td>
                    </tr>
                </template>
                </tbody>
                <tbody v-if="mpStore.tabs.length < 5">
                <tr>
                    <td colspan="5">
                        <a class="add-btn" @click="showPickerModal()">添加板块</a>
                    </td>
                </tr>
                </tbody>
            
            </table>
            
            <div>
                <button class="btn submit-btn" @click="submit()">保存</button>
                <div class="tooltip-box">
                    小程序底部导航栏空间限制，仅可开启4个版块
                </div>
            </div>
        
        </div>
        
        <at-modal v-model="pickerModalVisible" :footer="null" title="展示功能">
            <div class="mb-content">
                
                <template v-for="(item) in tabBars">
                    <div class="mb-item" :key="item.name" @click="itemSelect(item)">
                        <div class="selector " :class="{'selected': item.selected}"></div>
                        <div class="mb-item-icon">
                            <img :src="imageUrlFormat(item.activeIcon)" alt="">
                        </div>
                        <div class="mb-item-title">{{ item.title }}</div>
                    </div>
                </template>
            
            </div>
            <div class="mb-footer">
                <button class="btn" @click="confirmSelect()">确定</button>
            </div>
        </at-modal>
        
        <div class="mp-container" v-if="config" style=" pointer-events: none; ">
            <a-affix :offset-top="120">
                <mp ref="mp" :app-config="config" :service-sort="serviceSort"></mp>
            </a-affix>
        </div>
    </div>
</template>
<script>
import Mp from "@/views/AST/Xcx/Mp/Mp.vue";
import api from "@/repo/api";
import {allTabs, useMpStore} from "@/views/AST/Xcx/Mp/mp";
import AtModal from "@/components/AtModal.vue";
import Sortable from "sortablejs";
import AtInput from "@/components/AtInput.vue";
import SwitchButton from "@/components/SwitchButton.vue";

export default {
    components: {SwitchButton, AtInput, AtModal, Mp},
    setup() {
        const mpStore = useMpStore()
        return {mpStore}
    },
    data() {
        return {
            config: null,
            serviceSort: '',
            tabBars: [],
            pickerModalVisible: false,
        }
    },
    mounted() {
        this.fetchConfig()
        this.initSortAble()
    },
    methods: {
        initSortAble() {
            const tbody = this.$refs.sortTable;
            
            // 使用Sortable.js实现拖拽排序
            const sortable = Sortable.create(tbody, {
                handle: '.drag-handle',
                animation: 150,
                ghostClass: 'sortable-ghost',
                chosenClass: 'sortable-chosen',
                dragClass: 'sortable-drag',
                filter: 'thead',
                onEnd: () => {
                    // 获取拖拽后的新位置
                    
                    const names = sortable.toArray();
                    
                    const sortedTabs = [...this.mpStore.tabs].sort((a, b) => {
                        return names.indexOf(a.name) - names.indexOf(b.name);
                    });
                    
                    this.mpStore.setTabs(sortedTabs)
                }
            });
        },
        submit() {
            this.$loading.show()
            
            // only name,custom_title
            let config = this.mpStore.tabs.map(item => ({
                name: item.name,
                custom_title: item.custom_title,
                enabled: item.enabled
            }))
            
            api.post('/ast-app/save-config', {
                group: 'tab-bar',
                config: {
                    tab_bar: config
                }
            }, (res) => {
                
                this.$loading.hide()
                
                if (res.code !== 0) {
                    return this.$message.error(res.msg || '保存失败')
                }
                
                this.$message.success('已成功保存，手机端须重新进入小程序方可生效')
            })
        },
        showPickerModal() {
            let currNames = this.mpStore.tabs.map(item => item.name)
            
            this.tabBars = allTabs
                .filter(item => item.name !== 'my')
                .map(item => ({
                    ...item, // 浅拷贝属性
                    selected: currNames.includes(item.name) // 根据当前 Store 状态决定选中
                }))
            
            this.pickerModalVisible = true
        },
        confirmSelect() {
            let selectTabs = this.tabBars.filter(item => item.selected)
            
            this.mpStore.setTabs(selectTabs)
            
            this.pickerModalVisible = false
        },
        itemSelect(item) {
            
            if (!item.selected) {
                let selectCount = this.tabBars.filter(item => item.selected).length
                if (selectCount >= 4) return this.$message.error('受限制于小程序，最多开启4个板块');
            }
            
            this.$set(item, 'selected', !item.selected)
        },
        deleteTab(item) {
            if (item.name === 'my') return this.$message.error('不能删除我的板块');
            
            let tabs = this.mpStore.tabs.filter(tab => tab.name !== item.name)
            this.mpStore.setTabs(tabs)
        },
        imageUrlFormat(uri) {
            if (uri.indexOf('http') === 0) {
                return uri
            }
            return '/assets' + uri
        },
        
        fetchConfig() {
            api.get('/ast-app/config', (data) => {
                
                if (data.code === 0) {
                    this.config = data.data;
                    this.serviceSort = this.config.page_service_sort;
                    this.mpStore.initConfig(this.config)
                }
                
            });
        },
    }
    
}
</script>
<style lang="scss">
.block-page {
    position: relative;
}

.mp-container {
    position: absolute;
    right: 0;
    top: 0;
}

.bl-table {
    width: 510px;
    
    th, td {
        height: 60px;
        text-align: center;
        vertical-align: middle;
        user-select: none;
    }
    
    tr {
        border-bottom: 1px solid #EEEEEE;
    }
}

.sort-btn {
    width: 24px;
    height: 24px;
    background-image: url("/assets/images/home-sort-icon.png");
    background-size: 16px 16px;
    background-position: center;
    background-repeat: no-repeat;
    display: inline-block;
    cursor: move;
}

.mb-content {
    padding-bottom: 24px;
}

.mb-footer {
    border-top: 1px solid #EEEEEE;
    height: 56px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
}

.mb-content {
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    gap: 16px;
    flex-wrap: wrap;
}

.mb-item {
    width: 80px;
    height: 96px;
    background: #FAFAFA;
    border-radius: 4px;
    
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    cursor: pointer;
    user-select: none;
    position: relative;
    
    .selector {
        border: 1px solid rgb(204, 204, 204);
        width: 12px;
        height: 12px;
        border-radius: 50%;
        position: absolute;
        right: 4px;
        top: 4px;
        overflow: hidden;
        
        &.selected {
            width: 14px;
            height: 14px;
            background-image: url("/assets/icons/stock-selected.png");
            background-size: 100%;
        }
    }
    
    img {
        width: 48px;
        height: 48px;
        margin-bottom: 6px;
        user-select: none;
        -webkit-user-drag: none;
    }
    
    .mb-item-title {
        font-weight: 400;
        font-size: 12px;
        color: #333333;
        line-height: 16px;
    }
}

.del-btn {
    font-weight: 400;
    font-size: 14px;
    color: #F5606D;
    
    &:hover {
        color: #F5606D;
    }
}

.submit-btn {
    margin-top: 150px;
}

/* --- 核心代码：气泡框样式 --- */
.tooltip-box {
    position: relative; /* 关键：给伪元素定位做参考 */
    background-color: #f2f2f2; /* 浅灰色背景 */
    padding: 6px 24px; /* 内边距 */
    border-radius: 4px; /* 圆角 */
    font-weight: 400;
    font-size: 14px;
    color: #606266;
    display: inline-block; /* 让盒子宽度适应内容 */
    margin-left: 16px; /* 给箭头留出一点位置，或者让它紧贴 */
}

/* --- 核心代码：绘制左侧小三角形 --- */
.tooltip-box::before {
    content: '';
    position: absolute;
    
    /* 定位：垂直居中 */
    top: 50%;
    transform: translateY(-50%);
    
    /* 定位：放在盒子左侧外 */
    left: -16px; /* 负值等于 border-width 的两倍或者调整到合适位置 */
    
    /* 绘制三角形的核心技巧 */
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 8px; /* 控制三角形大小 */
    
    /* 颜色设置：
       上、下、左边框透明
       右边框颜色 = 气泡背景色 (#f2f2f2)
    */
    border-color: transparent #f2f2f2 transparent transparent;
}
</style>